export default __webpack_public_path__ + "static/media/logo-passtrack.bedcaefb.png";